export const state = {
  query: "",
  page: 1,
  perPage: 15,
  totalHits: 0,

  currentView: "gallery",
  currentFilter: "all",

  images: [],
  favorites: [],
};